const baseUrl = '/';

const headers = {
    'Content-Type': 'application/json',
};

export const getRequest = async <T>(url: string) => {
    const apiUrl = `${baseUrl}${url}`;

    return fetch(apiUrl, {
        headers,
    }).then((response) => {
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        return response.json() as Promise<T>;
    });
};

export const putRequest = async <T>(url: string, data: T) => {
    const apiUrl = `${baseUrl}${url}`;

    return fetch(apiUrl, {
        method: 'PUT',
        headers,
        body: JSON.stringify(data),
    }).then((response) => {
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        return response.json() as Promise<T>;
    });
};

export const postRequest = async <T>(url: string, data: T) => {
    const apiUrl = `${baseUrl}${url}`;

    return fetch(apiUrl, {
        method: 'POST',
        headers,
        body: JSON.stringify(data),
    }).then((response) => {
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        return response.json() as Promise<T>;
    });
};
